import { FUEL_PRICE_VIEW } from '@/fixtures'

export default {
  path: 'fuel-price-exchange-rate',
  component: () => import('@/views/Route'),
  children: [
    {
      path: '',
      name: 'Fuel Price & Exchange Rate',
      component: () => import('@/views/menus/FuelPriceExchangeRate/Index'),
      meta: {
        permission: FUEL_PRICE_VIEW
      }
    }
  ]
}
